import React, {Component} from 'react';

import styles from '../../../static/css/articleStyleModules/introArticle.module.scss';

import { CSSTransition } from 'react-transition-group';

import smartPhoneImage from '../../../static/img/smartPhoneIcon.svg';

import SvgIconBaseComponent from '../../svgIconComponents/SvgIconBaseComponent';

export default class IntroArticle extends Component {

    constructor(props){
        super(props);
        this.state = {
            isBrowser:true,
            
            page:0,
        }
    }

    componentWillMount = () => {
        if(window.matchMedia('(display-mode: standalone)').matches){
            // ここにPWA環境下でのみ実行するコードを記述
            this.setState({isBrowser:false});
        }
    }

    goToA2HSHelp = () => {
        this.props.onChangeArticle('A2HSHelp');
    }

    goToTutorial = () => {
        this.props.onChangeArticle('tutorial');
    }

    render() {

        const thankYouPage = (
            <div className={styles['pageArea'] + ' ' + styles['thankYouPage']}
            onClick={() => {this.setState({page:1})}}
            key={'thankYouPage'}>
              <div className={styles['gratitude']}>
                <span>見つけてくれて</span>
                <br></br>
                <strong>ありがとう！</strong>
              </div>
              <div className={styles['heartMark']}>
                <SvgIconBaseComponent image={'facedHeart'} fillColor={'hsl(6,77%,62%)'} />
              </div>
              <div className={styles['appIntroduction']}>
                <span>『ありがとログ』は<br></br>日々感じる『ありがとう』の気持ちを<br></br>いつ？誰に？<br></br>という感じでメモできる<br></br><b>ありがとう記録アプリ</b>です</span>
              </div>
            </div>
        )

        const thisAppIsPWA = (
            <div className={styles['pageArea']} 
            key={'offLineOkPage'}>
              <h2>webアプリなの？</h2>
              <p>いいえ、<b>スマホアプリです！</b><br/>『ありがとログ』はPWAといって、webページからダウンロードして使える、新しいスマホアプリです！</p>
              <img className={styles['eyeCatchImage']} src={smartPhoneImage} alt={'smartPhoneIcon'} />
              <h2>登録ナシ！オフラインもOK！</h2>
              <p>
                <span><b>会員登録などは不要</b>で使えます。入力したデータはアプリ自体に保存されるので、インターネットに接続していなくても使えます！</span>
                <br></br>
                <span>ただ、もちろん<b>アプリを消去してしまうとデータも消えてしまいます</b>のでご注意ください！</span>
              </p>
              {this.state.isBrowser === true &&
                  <div className={styles['pageBlockButton'] + ' touchActiveDark'}
                  onClick={() => this.goToA2HSHelp()}
                  >スマホアプリとして使うには？</div>
              }
              <div className={styles['pageBlockButton'] + ' touchActiveDark'}
              onClick={() => this.goToTutorial()}
              >{this.state.isBrowser ? 'このままとりあえず試してみる！' : '使ってみる！' }</div>
            </div>
        )

        const pageComponentArray = [
            thankYouPage,
            thisAppIsPWA,
        ]

        return (
            <div className={styles['introArticleArea']}>
              {pageComponentArray.map((value,index) => {
                  // return (this.state.page === index && value)
                  return (
                      <CSSTransition
                      in={this.state.page === index}
                      timeout={200}
                      classNames="simpleFadeIn200"
                      unmountOnExit
                      mountOnEnter
                      key={index}
                      >
                        {value}
                      </CSSTransition>
                  )

              })}
            </div>
        )
    }

};